/* Tradução mecânica; textos legais canônicos em pt-BR. Revisão jurídica por jurisdição não coberta nesta tradução. */
import { useNavigate } from 'react-router-dom'
import { ArrowLeft, FileText } from 'lucide-react'
import { Trans, useTranslation } from 'react-i18next'
import BrandLogo from '../../components/BrandLogo'

export default function TermsOfService() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b border-gray-200 sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-sm text-gray-500 hover:text-gray-700 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            {t('common.buttons.back')}
          </button>
          <BrandLogo className="h-8 w-auto object-contain" alt="Automais" />
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 sm:p-12">

          <div className="flex items-center gap-3 mb-2">
            <FileText className="w-7 h-7 text-primary-600 shrink-0" />
            <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">{t('legal.terms.title')}</h1>
          </div>
          <p className="text-sm text-gray-500 mb-8">{t('legal.terms.lastUpdate')}</p>

          <div className="prose prose-gray max-w-none space-y-8 text-gray-700">

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-3">{t('legal.terms.s1Title')}</h2>
              <p><Trans i18nKey="legal.terms.s1P1" components={{ b: <strong /> }} /></p>
              <p className="mt-2">{t('legal.terms.s1P2')}</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-3">{t('legal.terms.s2Title')}</h2>
              <p>{t('legal.terms.s2Body')}</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-3">{t('legal.terms.s3Title')}</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>{t('legal.terms.s3Item1')}</li>
                <li>{t('legal.terms.s3Item2')}</li>
                <li>
                  <Trans
                    i18nKey="legal.terms.s3Item3"
                    components={{
                      mail: (
                        <a
                          href="mailto:suporte@automais.io"
                          className="text-primary-600 hover:text-primary-700 underline"
                        />
                      ),
                    }}
                  />
                </li>
                <li>{t('legal.terms.s3Item4')}</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-3">{t('legal.terms.s4Title')}</h2>
              <p><Trans i18nKey="legal.terms.s4Intro" components={{ b: <strong /> }} /></p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>{t('legal.terms.s4Item1')}</li>
                <li>{t('legal.terms.s4Item2')}</li>
                <li>{t('legal.terms.s4Item3')}</li>
                <li>{t('legal.terms.s4Item4')}</li>
                <li>{t('legal.terms.s4Item5')}</li>
                <li>{t('legal.terms.s4Item6')}</li>
                <li>{t('legal.terms.s4Item7')}</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-3">{t('legal.terms.s5Title')}</h2>
              <p>{t('legal.terms.s5P1')}</p>
              <p className="mt-2">{t('legal.terms.s5P2')}</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-3">{t('legal.terms.s6Title')}</h2>
              <p>
                <Trans
                  i18nKey="legal.terms.s6Body"
                  components={{
                    privacy: (
                      <a href="/privacy-policy" className="text-primary-600 hover:text-primary-700 underline" />
                    ),
                  }}
                />
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-3">{t('legal.terms.s7Title')}</h2>
              <p>{t('legal.terms.s7P1')}</p>
              <p className="mt-2">{t('legal.terms.s7P2')}</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-3">{t('legal.terms.s8Title')}</h2>
              <p>{t('legal.terms.s8P1')}</p>
              <p className="mt-2">{t('legal.terms.s8P2')}</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-3">{t('legal.terms.s9Title')}</h2>
              <p>{t('legal.terms.s9Body')}</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-3">{t('legal.terms.s10Title')}</h2>
              <p>{t('legal.terms.s10Body')}</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-3">{t('legal.terms.s11Title')}</h2>
              <p>{t('legal.terms.s11Body')}</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-3">{t('legal.terms.s12Title')}</h2>
              <p>{t('legal.terms.s12Intro')}</p>
              <div className="mt-3 p-4 bg-gray-50 rounded-xl text-sm space-y-1">
                <p><strong>{t('legal.terms.companyName')}</strong></p>
                <p>
                  {t('legal.terms.emailLabel')}:{' '}
                  <a
                    href="mailto:suporte@automais.io"
                    className="text-primary-600 hover:text-primary-700 underline"
                  >
                    suporte@automais.io
                  </a>
                </p>
                <p>
                  {t('legal.terms.siteLabel')}:{' '}
                  <a
                    href="https://automais.io"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary-600 hover:text-primary-700 underline"
                  >
                    automais.io
                  </a>
                </p>
              </div>
            </section>

          </div>
        </div>

        <p className="text-center text-xs text-gray-400 mt-8 pb-6">
          {t('legal.footer', { year: new Date().getFullYear() })}
        </p>
      </main>
    </div>
  )
}
